<template>
  <div class="snow-button-switch">
    <snow-button
      v-for="(item, index) in options"
      :name="`button-switch-${item.value}`"
      :icon="item.icon"
      :text="item.title"
      :key="index"
      :variant="value === item.value ? 'gray' : 'borderless'"
      @click="$emit('input', item.value)"
    />
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [{}, {}]
    },
    value: {
      type: [Number, String, Object, Boolean],
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
.snow-button-switch {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
